<div id="wrapper">
    <app-user-header />
    <div id="main-content" class="main-content">
        <div class="container-fluid">
            <router-outlet />
        </div>
        <app-user-footer />
    </div>
</div>